import { apiEndpoint, retryApi } from ".";

export interface CreateEntryRequest {
  name: string;
  value: string;
  type?: "String" | "SecureString";
  skipRetry?: boolean;
}

export interface CreateEntryResponse {
  message: string;
  version?: number;
}

export async function createEntry(
  req: CreateEntryRequest,
): Promise<CreateEntryResponse | undefined> {
  const token = localStorage.getItem("authToken");
  if (token) {
    const response = await fetch(`${apiEndpoint}/parameter`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(req),
    });

    if (!response.ok) {
      if ([401, 403].includes(response.status) && !req.skipRetry) {
        return retryApi({
          func: createEntry,
          funcProps: { name: req.name, value: req.value, type: req.type },
          response,
          token,
        });
      }
      // Extract error message if backend sends one
      const errText = await response.text();
      throw new Error(`Failed to create entry: ${response.status} ${errText}`);
    }

    return (await response.json()) as CreateEntryResponse;
  }
}
